export * from "-!../../../../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./language.vue?vue&type=template&id=4ad1c066&scoped=true"


//////////////////
// WEBPACK FOOTER
// ./src/components/clients/client/settings/view/language.vue?vue&type=template&id=4ad1c066&scoped=true
// module id = FDTG
// module chunks = 0